import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { ApiResponse } from '@/types/api.types';

function fetchEnabledModules() {
  return apiClient.get<ApiResponse<string[]>>('/modules');
}

export function useEnabledModules() {
  return useQuery({
    queryKey: ['modules'],
    queryFn: fetchEnabledModules,
    select: (res) => res.data.data,
    staleTime: 60_000,
  });
}

export function useHasModule(module: string) {
  const { data = [] } = useEnabledModules();
  return data.includes(module);
}
